// extracted by mini-css-extract-plugin
module.exports = {"buttons":"UploadResult_buttons_3H1Hx","preview":"UploadResult_preview_17ZqA"};